import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function PolicySection({ title, text = [] }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        borderBottom: "1px solid #ddd",
        padding: "16px 0",
      }}
    >
      <div
        onClick={() => setOpen(!open)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <h3 style={{ margin: 0, color: "#6b4fa3", fontSize: "20px" }}>{title}</h3>
        <span>{open ? "▲" : "▼"}</span>
      </div>

      {open && (
        <div style={{ marginTop: 12, color: "#444" }}>
          {text.map((line, i) => (
            <p key={i} style={{ margin: "8px 0", lineHeight: 1.6 }}>
              {line}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}

export default function PolicyPage() {
     const navigate = useNavigate();
  return (
    <div style={{ maxWidth: 1000, margin: "0 auto", padding: 20 }}>
        <button
  onClick={() => navigate("/dashboard?quicklinks=true")}
  style={{
    marginBottom: 20,
    padding: "10px 16px",
    backgroundColor: "#6b4fa3",
    color: "white",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: 500,
  }}
>
  ← Return to Quick Links
</button>

      <h1 style={{ marginBottom: 10 }}>Policies</h1>
      <p style={{ marginBottom: 30, color: "#666" }}>
       
      </p>

      <PolicySection
    title="Compensation"
    text={[
    "Hourly Wages:",
    "EMTs: $21.00/hour",
    "AEMTs: $22.00/hour",
    "Paramedics: $34.00/hour",
    "RNs (Non-THON Employees): $34.00/hour",
    "You will receive your paycheck approximately two weeks after the event.",
    "Your wages are reported to the IRS. You will receive a 1099 from Trinity Health of New England in January 2027.",
    "All employees are required to submit a W-9.",
  ]}
/>

      <PolicySection
        title="Hours of Work"
        text={[
          "All shifts begin at 0600 sharp and go until the end of play, usually around 1900. Please allow five minutes to walk in from the parking lot and be at medical headquarters by 0600.",
        ]}
      />

      <PolicySection
        title="Attendance and Punctuality"
        text={[
          "It is important for you to report to work on time. We recognize that illness or other circumstances beyond your control may cause you to be absent. However, frequent absenteeism or tardiness may result in removal from the schedule and exclusion from further events.",
        ]}
      />

      <PolicySection
        title="Schedule"
        text={[
          "The schedule is typically released on or around May 1st. Preference is given to current team members and those who apply prior to April 15th.",
          "Your scheduled shifts will appear on your dashboard. If you can no longer work any of your shifts, click the 'Request Time Off' button next to that shift.",
          "Open shifts, that you are qualified for, will also appear on your dashboard. You can request an open shift by clicking the 'Request Shift' button.",
          "Open shifts will be awarded to those with the least amount of scheduled hours first, then by the order the request was received.",
        ]}
      />

      <PolicySection
        title="Time Clock"
        text={[
          "All employees are required punch in and out using the time clock feature on your dashboard.",
          "Trinity Health Employees will also need to punch in and out using the Trinity Health time clock.",
          "You can view your timecard on your dashboard. Trinity Health employees will only see hours worked on their time cards as you will be paid in your regular paycheck.",
          "You are not permitted to punch in prior to 0545 without approval from a member of the Command Team.",
        ]}
      />

      <PolicySection
        title="Dress Code"
        text={[
          "As a member of our team, we expect you to present a clean and professional appearance when you represent us. This includes shirts tucked in and sleeves rolled down. Team members should wear navy blue or khaki shorts (at least mid-thigh in length). Pants are acceptable as well (navy blue or khaki) NO JEANS.",
          "Golf course terrain is uneven and can be slippery when wet. Comfortable sneakers are suggested. ",
          "The following items will be provided and must be worn while you are working:",
          "1. Official Shirt",
          "2. Official Hat",
          "3. Official Rain Gear (during inclement weather)",
          "Items bearing the logo of other services are strictly prohibited.",
        ]}
      />

      <PolicySection
        title="Phones"
        text={[
          "Phones are allowed on the course however, we ask that they be kept on silent and their use be limited during the event.",
        ]}
      />

      <PolicySection
        title="Social Media"
        text={[
          "The term Social Media includes all means of communicating or posting information or content on the internet. You are permitted to post images of the event on social media. However, posts must be appropriate and portray our organization in a positive light. Inappropriate posts, include but are not limited to discriminatory remarks, harassment and threats of violence, unlawful conduct, posts that violate HIPPA laws and photos in restricted areas.",
          "If you're questioning whether or not a photo is appropriate, it's probably not.",
        ]}
      />

      <PolicySection
        title="Smoking"
        text={[
          "Please refrain from smoking in public areas. ",
        ]}
      />

      <PolicySection
        title="Autographs"
        text={[
          "We kindly ask our team members to refrain from asking for autographs or photos with players. Please remember that we are representing Trinity Health and the PGA Tour. We are not spectators.",
        ]}
      />
    </div>
  );
}